export default class pegErrorDialog500 extends HTMLElement {
	connectedCallback() {
		this.querySelectorAll('.js-reloadPage').forEach((reloadLink) => {
			reloadLink.addEventListener('click', (event) => {
				event.preventDefault();
				document.location.reload();
			});
		});
	}
}
